import { render, staticRenderFns } from "./PatternSetupGrid.vue?vue&type=template&id=034cfa0f"
import script from "./PatternSetupGrid.vue?vue&type=script&lang=js"
export * from "./PatternSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports